<script setup >
import { inject } from 'vue'
import stripslashes from '@/Shared/helper.js'
const data = inject('data')
</script>

<template>
  <div class="relative md:py-20 lg:py-32 border-b-2 border-[#eee] bg-[#f1f1f1]">
    <div class="relative mx-auto">
      <div class="brand-video" v-html="stripslashes(data.extra.brandDetailHTML2)" />
    </div>
  </div>
</template>


